export default function () {
	const body = document.getElementsByTagName('BODY')[0];
    const prevBtn = document.getElementById('mainmenuPrev');
    let activeMenu = null;

    function toggleNavLink(event) {
        if (!event.target.matches('.nlt')) return;
        activeMenu = event.target.parentElement;
        activeMenu.classList.add('show');
        if (prevBtn != null) {
            prevBtn.classList.add('show');
        }
    }

    function prevMainMenu(event) {
        if (!event.target.matches('#mainmenuPrev')) return;
        activeMenu.classList.remove('show');
        const parentEl = activeMenu.parentElement.parentElement;
        if (parentEl.classList.contains('dropdown')) {
            activeMenu = parentEl;
        } else {
            activeMenu = null;
            prevBtn.classList.remove('show');
        }
    }

    document.addEventListener('click', function (event) {
        toggleNavLink(event);
        prevMainMenu(event);
    });

    const navSector = document.querySelectorAll('.nav-sector');
    for (let i = 0; i < navSector.length; i++) {
        navSector[i].addEventListener('mouseenter', function (event) {
            body.classList.add('open-sectormenu');
        });
        navSector[i].addEventListener('mouseleave', function (event) {
            body.classList.remove('open-sectormenu');
        });
    }

	const navDropdown = document.querySelectorAll('.nav-ddm');
    for (let i = 0; i < navDropdown.length; i++) {
        navDropdown[i].addEventListener('mouseenter', function (event) {
            navDropdown[i].classList.add('hover');
            body.classList.add('open-ddm');
        });
        navDropdown[i].addEventListener('mouseleave', function (event) {
            navDropdown[i].classList.remove('hover');
			body.classList.remove('open-ddm');
        });
    }

    // let scrollPos = 0;
    const scrollPosSticky = 10;
    // const scrollPosHidden = 400;

    function checkPosition() {
        const windowY = window.scrollY;

        if (windowY < scrollPosSticky) {
            body.classList.remove('is-sticky');
        } else {
            body.classList.add('is-sticky');
		}

        // if (windowY < scrollPosHidden) {
        //     body.classList.remove('is-hidden');
        // } else {
        //     body.classList.add('is-hidden');
        // }

        // if (windowY < scrollPos) {
        //     body.classList.remove('is-hidden');
        // }

        // scrollPos = windowY;
    }

    checkPosition();
    window.addEventListener('scroll', checkPosition);
};
